module.exports = __webpack_public_path__ + "img/2w.fa6c2e55.svg";